<h2 class="sr-only">{{ "StandardSuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="standardRequest" #form="ngForm">
  <h3 class="title-divider-suche">{{ "grundstueckHeading" | translate }}</h3>
  <cap-form-row column-classes="col-md-2,col-md-4">
    <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="GemeindeMussVorhandenSein" labelKey="Gemeinde">
      <cap-gwr-gemeinde
        (ngModelChange)="standardRequest && (standardRequest.gemeindeEntry = $event)"
        [ngModel]="standardRequest && standardRequest.gemeindeEntry"
        class="typeahead-holder"
        name="gemeindeEntry"></cap-gwr-gemeinde>
      <button (click)="emptyGemeindeSearch()" class="btn btn-white" tabindex="-1" type="button">
        <span class="fas fa-times"></span>
      </button>
    </cap-form-control>
    <cap-form-control column-classes="col-md-1,col-md-1" invalidKey="EingabeMussValideGrundstueckNummerSein" labelKey="Nummer">
      <input
        (ngModelChange)="standardRequest && (standardRequest.grundstueckNummer = $event)"
        [ngModel]="standardRequest && standardRequest.grundstueckNummer"
        name="grundstueckNummer"
        size="6"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <cap-form-row>
    @if (searchForEgrid) {
      <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussValideEgridSein" labelKey="EGRID">
        <input
          (ngModelChange)="standardRequest && standardRequest.egrid && (standardRequest.egrid.value = $event)"
          [ngModel]="standardRequest && standardRequest.egrid && standardRequest.egrid.value"
          name="egrid"
          type="text" />
      </cap-form-control>
    }
  </cap-form-row>

  <h3 class="title-divider-suche">{{ "meldungGebaeudeHeading" | translate }}</h3>
  <cap-form-row>
    <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussValideVersicherungsNummerSein" labelKey="VersicherungsNr">
      <input
        (ngModelChange)="standardRequest && (standardRequest.versicherungsNummer = $event)"
        [ngModel]="standardRequest && standardRequest.versicherungsNummer"
        name="versicherungsNummer"
        size="20"
        type="text" />
    </cap-form-control>
  </cap-form-row>

  <cap-form-row class="mb-md-4">
    <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussJahrSein" labelKey="Baujahr">
      <input
        (ngModelChange)="standardRequest && (standardRequest.baujahr = $event)"
        [ngModel]="standardRequest && standardRequest.baujahr"
        name="baujahr"
        size="6"
        type="text" />
    </cap-form-control>
  </cap-form-row>

  <h3 class="title-divider-suche">{{ "gebäudeeingangHeading" | translate }}</h3>

  <cap-form-row class="mb-md-2">
    <cap-form-control
      column-classes="col-md-2,input-series col col-md-3"
      invalidKey="gwr.EingabeMussGueltigeStrasseSein"
      labelKey="StrasseOderHausnummer">
      <input
        (ngModelChange)="standardRequest && (standardRequest.strasse = $event)"
        [ngModel]="standardRequest && standardRequest.strasse"
        name="strasse"
        size="20"
        type="text" />
    </cap-form-control>
    <cap-form-control column-classes="col-md-2, input-series col col-md-1 col-sm-2" invalidKey="EingabeMussGueltigeHaunsummerSein">
      <input
        (ngModelChange)="standardRequest && (standardRequest.eingangsNr = $event)"
        [ngModel]="standardRequest && standardRequest.eingangsNr"
        name="eingangsNr"
        size="6"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
